import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactFormElevated';
import ParallaxBackground from '../components/ParallaxBackground';

const NewConstruction = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen"
    >
      <ParallaxBackground 
        image="/images/boathouse-row.jpg"
        className="py-32"
        overlay={true}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
            New Construction
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            Specialized closing services for new construction projects
          </p>
        </div>
      </ParallaxBackground>

      <section className="py-16 bg-eagle-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-eagle-dark mb-4">
              New Construction Services
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Embarking on a new construction project is an exciting endeavor, but it also comes with a unique set of challenges. At Eagle Closing, we specialize in providing comprehensive closing services tailored to the needs of new construction projects. Our experienced team is dedicated to ensuring a seamless and successful closing process from the inception of the project to its completion.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Expert Guidance',
                description: 'Our team understands the intricacies of new construction transactions. We offer expert guidance and support, helping you navigate the specific legal and logistical requirements involved in closing a new construction project.',
              },
              {
                title: 'Title Examination and Insurance',
                description: 'We conduct thorough title examinations to ensure the property has a clear title, free from any liens or encumbrances. Additionally, we assist in obtaining title insurance, providing protection against unforeseen title defects that may arise in the future.',
              },
              {
                title: 'Coordination with Stakeholders',
                description: 'We act as a central point of contact, coordinating with all relevant stakeholders involved in the new construction project. This includes builders, developers, lenders, real estate agents, and attorneys. Our goal is to ensure clear communication and timely exchange of information throughout the construction process.',
              },
              {
                title: 'Review and Preparation of Documents',
                description: 'Our team meticulously reviews and prepares all necessary legal documents, including contracts, purchase agreements, and construction agreements. We ensure that all documents comply with local regulations and accurately reflect the terms and conditions of the project.',
              },
              {
                title: 'Timely and Efficient Closings',
                description: 'We understand the importance of meeting project deadlines. With our streamlined processes and attention to detail, we strive to facilitate timely and efficient closings, allowing for a smooth transition from construction to ownership.',
              },
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-eagle-dark mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 mb-8">
              At Eagle Closing, we pride ourselves on delivering exceptional service and support to clients involved in new construction projects. Our commitment to professionalism, integrity, and efficiency sets us apart, ensuring that your new construction closing is handled with the utmost care.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Contact us today to learn more about our new construction services and how we can assist you in successfully closing your new construction project. Trust Eagle Closing to be your reliable partner, dedicated to bringing your vision to fruition through a seamless and successful closing process.
            </p>
          </div>
        </div>
      </section>
      
      {/* Contact Form with Parallax */}
      <ContactForm backgroundImage="/images/benjamin-franklin-bridge.jpg" />
    </motion.div>
  );
};

export default NewConstruction;

